import { render } from "./EditSection.vue?vue&type=template&id=cbffb398&scoped=true"
import script from "./EditSection.vue?vue&type=script&lang=js"
export * from "./EditSection.vue?vue&type=script&lang=js"

import "./EditSection.vue?vue&type=style&index=0&id=cbffb398&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbffb398"]])

export default __exports__